import { NotificationType } from '@bannerflow/types.notification-service';
import { PredictiveScoringCompletedNotification } from '../domain';

// Studio's Predictive Scoring modal wording. Image→static, Video→animated.
function getAnalysisSubject(analysisKind: string | undefined): string {
  switch (analysisKind) {
    case 'Image':
      return 'static analysis';
    case 'Video':
      return 'animated analysis';
    default:
      return 'analysis';
  }
}

export function getPredictiveScoringTitle(
  notification: PredictiveScoringCompletedNotification
): string {
  switch (notification.type) {
    case NotificationType.Success:
      return 'Predictive scoring insights are ready';
    case NotificationType.Error:
      return 'Predictive scoring failed';
    default:
      return 'Predictive scoring';
  }
}

export function getPredictiveScoringLinkCaption(
  notification: PredictiveScoringCompletedNotification
): string | undefined {
  switch (notification.type) {
    case NotificationType.Success:
      return 'See results';
    case NotificationType.Error:
      return 'Open creative';
    default:
      return undefined;
  }
}

export function getPredictiveScoringMessage(
  notification: PredictiveScoringCompletedNotification
): string {
  const subject = getAnalysisSubject(
    notification.content.metadata.analysisKind
  );
  switch (notification.type) {
    case NotificationType.Success:
      return `Your ${subject} is ready.`;
    case NotificationType.Error:
      return `Your ${subject} failed. Please try again.`;
    default:
      return '';
  }
}
